const WEBOS_USER_AGENT = /(?:Web0S|webOS|NetCast|LG Browser)/i

function mediaMatches(browserWindow, query) {
    try {
        return Boolean(browserWindow?.matchMedia?.(query).matches)
    } catch (_) {
        return false
    }
}

export function getRuntimeProfile(
    browserWindow = typeof window === 'undefined' ? null : window,
    browserNavigator = typeof navigator === 'undefined' ? null : navigator
) {
    const userAgent = String(browserNavigator?.userAgent || '')
    const isWebOs = WEBOS_USER_AGENT.test(userAgent)
    const chromiumMatch = userAgent.match(/(?:Chrome|Chromium)\/(\d+)/i)
    const webOsChromeMajor = isWebOs && chromiumMatch ? Number(chromiumMatch[1]) : null
    const reducedMotion = mediaMatches(browserWindow, '(prefers-reduced-motion: reduce)')
    const compactTouch = mediaMatches(browserWindow, '(pointer: coarse)')
        && Number(browserWindow?.innerWidth || 0) <= 1000
    const saveData = Boolean(browserNavigator?.connection?.saveData)
    const deviceMemory = Number(browserNavigator?.deviceMemory || 0)
    const hardwareConcurrency = Number(browserNavigator?.hardwareConcurrency || 0)
    const lowMemory = deviceMemory > 0 && deviceMemory <= 4
    const lowCpu = hardwareConcurrency > 0 && hardwareConcurrency <= 4

    return {
        isWebOs,
        webOsChromeMajor,
        reducedMotion,
        compactTouch,
        saveData,
        performanceLite: isWebOs || compactTouch || reducedMotion || saveData || lowMemory || lowCpu,
        allowBackgroundVideo: !compactTouch
            && !reducedMotion
            && !saveData
            && (!isWebOs || (webOsChromeMajor !== null && webOsChromeMajor >= 87)),
    }
}

export function applyRuntimeProfile(
    documentObject = typeof document === 'undefined' ? null : document,
    browserWindow = typeof window === 'undefined' ? null : window,
    browserNavigator = typeof navigator === 'undefined' ? null : navigator
) {
    const profile = getRuntimeProfile(browserWindow, browserNavigator)
    const root = documentObject?.documentElement
    root?.classList?.toggle('platform-webos', profile.isWebOs)
    root?.classList?.toggle('performance-lite', profile.performanceLite)
    return profile
}

export function isStandaloneWebApp(
    browserWindow = typeof window === 'undefined' ? null : window,
    browserNavigator = typeof navigator === 'undefined' ? null : navigator
) {
    return Boolean(
        browserNavigator?.standalone
        || mediaMatches(browserWindow, '(display-mode: standalone)')
        || mediaMatches(browserWindow, '(display-mode: fullscreen)')
    )
}
